import { render, staticRenderFns } from "./AddCustomMetadata.vue?vue&type=template&id=108d9ec4&scoped=true"
import script from "./AddCustomMetadata.vue?vue&type=script&lang=js"
export * from "./AddCustomMetadata.vue?vue&type=script&lang=js"
import style0 from "./AddCustomMetadata.vue?vue&type=style&index=0&id=108d9ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d9ec4",
  null
  
)

export default component.exports